import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchemaPl';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';
import mealPlanSettingsStepsSchema from './MealPlanSettings/stepsSchemaPl';
import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['pl-PL', 'cs-CZ'];

export const SENTRY_DSN = ''; // TODO: add SENTRY_DSN

export const APP_STORE_URL =
  'https://apps.apple.com/pl/app/oxy-treningi-i-prosta-dieta/id1195551690';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=pl.dietaoxy&hl=pl';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'oxy';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://dietaoxy.pl/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'oxy',
  name: 'oxy',
  themeColor: '#ffffff',
  title: 'Dieta Oxy',
  description: 'Treningi i Prosta Dieta',
  keywords: ['oxy'],
  author: 'activerse.app',
};

export const FRISCO = true;
export const FRISCO_FIREBASE_FUNCTION = 'https://oxyfriscogenerator-2kuvjcv4xa-uc.a.run.app';
export const FRISCO_PARTNER = 'OXY';
export const FRISCO_DESKROP_URL_PL = 'https://dietaoxy.pl/frisco/';
export const FRISCO_DESKROP_URL_CZ = 'https://dietaoxy.pl/frisco/';

export const INSTACART_FIREBASE_FUNCTION = 'https://oxyinstacartgenerator-2kuvjcv4xa-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;
export const FIRST_MEAL_PLAN_SETTINGS_STEP_SLUG = mealPlanSettingsStepsSchema[0].slug;

export const FORCE_BUILD = false;

export const OPEN_APP_URL = 'https://get.oxydiet.com/MlMk/';
